import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";

export const searchApi = async (search: string) => {
  const { data } = await api.post(
    API_ROUTES.BONUSES_LIST,
    qs.stringify({ ...defaultOptions(), bonus_type_id: 1, search })
  );

  return data;
};
